import React from 'react';

const EmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  className = '',
  ...props
}) => {
  return (
    <div
      className={`text-center py-16 px-6 rounded-2xl border border-dashed border-ink-200 bg-white/60 ${className}`}
      {...props}
    >
      {Icon && (
        <div className="mx-auto mb-5 inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-gradient-to-br from-brand-50 to-brand-100 text-brand-600 ring-1 ring-brand-200/60">
          <Icon className="h-7 w-7" />
        </div>
      )}

      {title && (
        <h3 className="text-base font-semibold text-ink-900 tracking-tight">
          {title}
        </h3>
      )}

      {description && (
        <p className="mt-1.5 text-sm text-ink-500 max-w-sm mx-auto leading-relaxed">
          {description}
        </p>
      )}

      {action && (
        <div className="mt-6 flex justify-center">{action}</div>
      )}
    </div>
  );
};

export default EmptyState;
